import { IA_SERVICE_API } from '../config/config';

const toArray = (value) => (Array.isArray(value) ? value : []);

const getProductSource = (product) => product?.article || product || {};

const getImageUrl = (image) => {
  if (typeof image === 'string') return image;
  return image?.url || image?.image_url || image?.imageUrl || image?.src || image?.path || '';
};

const getSizes = (variant) => {
  if (Array.isArray(variant?.sizes) && variant.sizes.length > 0) {
    return variant.sizes.filter(Boolean);
  }

  return toArray(variant?.size_details)
    .map((detail) => detail?.size)
    .filter(Boolean);
};

const mapProduct = (product) => {
  const source = getProductSource(product);
  const variants = toArray(product?.variants || product?.type_detail || source?.type_detail)
    .map((variant) => ({
      color: variant?.color || '',
      sizes: getSizes(variant),
    }))
    .filter((variant) => variant.color || variant.sizes.length > 0);

  return {
    id: product?.id || product?._id || product?.article_id || source?.id || source?._id,
    name: product?.name || source?.name || '',
    description: product?.description || source?.description || '',
    price: product?.price ?? product?.sale_price ?? product?.prices?.sale_price ?? source?.price ?? source?.prices?.sale_price,
    category: product?.category?.name || product?.category_name || source?.category?.name,
    images: toArray(product?.images || source?.images).map(getImageUrl).filter(Boolean),
    variants,
  };
};

export const mapChatResponse = (payload) => {
  const products = toArray(payload?.products || payload?.data?.products || payload?.results)
    .map(mapProduct)
    .filter((product) => product.name || product.id);

  return {
    sessionId: payload?.session_id || payload?.sessionId || '',
    content: payload?.message || payload?.content || '',
    type: products.length > 0 ? 'products' : 'text',
    products,
  };
};

const sendMessage = async (sessionId, message) => {
  const response = await IA_SERVICE_API.post('/api/v1/chat/message', {
    session_id: sessionId,
    message,
  });

  return mapChatResponse(response.data);
};

const ChatService = { sendMessage };

export default ChatService;